import { render, staticRenderFns } from "./Closed.vue?vue&type=template&id=4df40b43&scoped=true"
var script = {}
import style0 from "./Closed.vue?vue&type=style&index=0&id=4df40b43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df40b43",
  null
  
)

export default component.exports